type TrpcErrorShape = {
  data?: {
    httpStatus?: number;
    code?: string;
  };
  shape?: {
    code?: string;
  };
  message?: string;
};

const AUTH_HTTP_STATUSES = new Set([401, 403]);
const AUTH_CODES = new Set(['UNAUTHORIZED', 'FORBIDDEN']);

export function isAuthError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const maybe = error as TrpcErrorShape;
  const httpStatus = maybe.data?.httpStatus;
  if (httpStatus && AUTH_HTTP_STATUSES.has(httpStatus)) {
    return true;
  }
  const code = maybe.data?.code ?? maybe.shape?.code;
  return !!code && AUTH_CODES.has(code);
}
